export default __webpack_public_path__ + "static/media/excel_icon.61ee82a3.png";